module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/sponsors.json
// module id = 389
// module chunks = 27511113389415